import { filterContacts } from 'common/api/v1/contacts';

import {
    FETCH_FILTER_CONTACTS,
    FETCH_FILTER_CONTACTS_FAILURE,
    FETCH_FILTER_CONTACTS_SUCCESS,
    SHOW_EMPTY_STATE,
} from '../actionTypes';
import { contactActions } from '../reducer';

export default ({
        orderBy,
        page,
        pageSize,
        searchText,
        sortBy,
        status,
        userId,
    } = {}) =>
    (dispatch) => {
        dispatch(contactActions[FETCH_FILTER_CONTACTS]());
        dispatch(
            contactActions[SHOW_EMPTY_STATE]({
                status,
                show: false,
            }),
        );

        filterContacts({
            orderBy,
            page: page + 1,
            perPage: pageSize,
            searchText,
            sortBy,
            status,
            userId,
        })
            .then((response) => {
                dispatch(
                    contactActions[FETCH_FILTER_CONTACTS_SUCCESS](
                        response.data,
                    ),
                );
                dispatch(
                    contactActions[SHOW_EMPTY_STATE]({
                        status,
                        show: response?.data?.data?.length === 0 || false,
                    }),
                );
            })
            .catch((error) =>
                dispatch(
                    contactActions[FETCH_FILTER_CONTACTS_FAILURE](
                        error?.response?.data?.errors,
                    ),
                ),
            );
    };
